import React, {useState, useEffect} from 'react';
import zhCN from 'antd/es/locale/zh_CN';
import enUS from 'antd/es/locale/en_US';
import { useTranslation } from 'react-i18next';
import './i18n'; 
import { ConfigProvider } from 'antd';
import Login from './Login'
import Home from './Home'
import { ThemeContext } from './Http'
import cookie from 'react-cookies';

function App() {
    const { t, i18n } = useTranslation()
    const [locale, setLocale] = useState(enUS); 
    let [session, setSession] = useState(null);
    let [whichSystem, setWiWhichSystem] = useState("BMS");

    useEffect(() => {
        // Get language from cookie or browser settings
        const cookieLang = document.cookie.split(';').find(row => row.trim().startsWith('language='));
        let initialLang;
        
        if (cookieLang) {
            // Use language from cookie if available
            initialLang = cookieLang.split('=')[1].trim();
        } else {
            // Fallback to browser language
            const browserLang = navigator.language || navigator.userLanguage;
            initialLang = browserLang.toLowerCase().startsWith('zh-cn') ? 'zh' : 'en';
        }

        // Set initial language
        i18n.changeLanguage(initialLang);
        setLocale(initialLang === 'en' ? enUS : zhCN);
    }, []);

    const toggleLanguage = (lang) => {
        i18n.changeLanguage(lang); 
        setLocale(lang === 'en' ? enUS : zhCN); 
        cookie.save('language', lang);
    };

    return (
        <ConfigProvider locale={locale}>
            {session === null 
            ? 
            <Login key="Login" onLoginSuccess={(s, w) => {
                setSession(s);
                setWiWhichSystem(w);
            }} onToggleLanguage={toggleLanguage}/> 
            : 
            <ThemeContext.Provider value={session}>
                <Home whichSystem={whichSystem} onLogout={()=>{
                    setSession(null);
                }} onChangeSystem={(w)=>{
                    setWiWhichSystem(w);
                }} onToggleLanguage={toggleLanguage}/>
            </ThemeContext.Provider>}
        </ConfigProvider>
  );
}

export default App;

